import type { TSizes } from '@alfa-bank/site-tag/src/models';

import type { IState, IMiddleNameSettings, TGendersShort } from './models';

const FEMALE_SHORT = 'f';
const MALE_SHORT = 'm';
const UNKNOWN_SHORT = '';

export const FEMALE = 'FEMALE';
export const MALE = 'MALE';
export const UNKNOWN = 'UNKNOWN';

interface IGenders {
    label: string;
    value: TGendersShort;
}

interface IGenderDefault {
    caption: string;
    errorCaption: string;
    name: string;
    size: TSizes;
}

export const mapFormGender = {
    [FEMALE]: FEMALE_SHORT,
    [MALE]: MALE_SHORT,
    [UNKNOWN]: UNKNOWN_SHORT,
};

export const genders: IGenders[] = [
    { value: FEMALE_SHORT, label: 'Женский' },
    { value: MALE_SHORT, label: 'Мужской' },
];

export const hasMiddleNameDefault: IMiddleNameSettings = {
    caption: 'По паспорту без отчества',
    name: 'hasMiddleName',
    size: 'm',
    theme: 'white',
    type: 'checkmark',
};

export const genderDefault: IGenderDefault = {
    caption: 'Пол',
    errorCaption: 'Поле обязательно для заполнения',
    name: 'sex',
    size: 'm',
};

const defaultName = <T extends '' | []>(arg: () => T) => ({
    firstName: arg(),
    lastName: arg(),
    middleName: arg(),
});

export const defaultState: IState = {
    gender: { ...defaultName(() => '') },
    options: { ...defaultName(() => []) },
    supposeGender: UNKNOWN,
    hasMiddleName: true,
    mouseOverCheckbox: false,
};

/** Задержка запроса к дадате */
export const DEFAULT_REQUEST_DELAY = 1000;
